import { IS_APP } from '../constants';

const initialState = {
  isApp: null
};

export function deviceReducer(state = initialState, action) {
  switch (action.type) {
    case IS_APP:
      return {
        ...state,
        isApp: action.payload
      };
    default:
      return state;
  }
};